import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  addFeatureButtonSectionHeader: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLight,
    },
  },
  addFeatureButtonSectionHeaderDisabled: {
    backgroundColor: theme.palette.neutralLighter,
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLighter,
    },
    cursor: 'default',
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    marginTop: pxToRem(35),
  },
  panelHeading: {
    selectors: {
      '.ms-Panel-headerText': {
        padding: `${pxToRem(14)} 0 ${pxToRem(4)} ${pxToRem(8)}`,
        borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
      },
    },
  },
  advanceGroupCardModule: {
    borderBottom: `0px`,
    marginBottom: pxToRem(-10),
    marginTop: pxToRem(-10),
  },
  detailsRowStyle: {
    marginBottom: pxToRem(10),
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
  },
  messageBarTitle: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
    marginTop: pxToRem(12),
  },
  messageBarBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  newAdvanceGroupModule: {
    paddingLeft: pxToRem(10),
    paddingRight: pxToRem(10),
  },
  cardContentWrapper: {
    borderBottom: `0px`,
    paddingTop: pxToRem(5),
    paddingBottom: pxToRem(5),
    marginLeft: pxToRem(-15),
    marginRight: pxToRem(-15),
  },
});
